import { APIClient } from '@innerhive-internal/innerhive-api-client';

export interface IExistingTag {
    name: string;
    count: number;
    lastUsedAt: string;
}

export interface IExistingTagsResponse {
    tags: IExistingTag[];
}

export class CareMapTagsClient {
    static inject = () => [APIClient];
    constructor(private apiClient: APIClient) {}

    getExistingTags = async ({
        userId,
        careMapId,
        sortBy = 'count'
    }: {
        userId: string;
        careMapId: string;
        sortBy?: 'count' | 'recency'
    }): Promise<IExistingTagsResponse> => {
        const url = `/users/${userId}/caremaps/${careMapId}/tags${sortBy === 'recency' ? '?sortBy=recency' : ''}`;
        return await this.apiClient.get({ href: url });
    };
}
